<template>
    <div class="container">
        <div class="row justify-content-center align-items-center py-2 my-3">
            <p class="page-title-header-text mb-0">Select your sport below:</p>
        </div>
        <hr class="line-break">
        <div class="sports-container">
            <div class="sports-icon-box" v-for="(activeSport, index) in orderedActiveSports" :key="index"
                 v-bind:class="[sportHasActiveRounds(activeSport.name) ? activeClass : inActiveClass]"
                 v-on:click="onSportClicked(activeSport.name)">
                <img v-if="!sportHasActiveRounds(activeSport.name)" class="coming-soon-banner"
                     :src="getComingSoonBanner()" alt="">
                <img class="sports-icon" :src="getImage(activeSport.iconPath)" alt="">
                <p class="icon-text">Predict {{ activeSport.name }}!</p>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapMutations, mapState} from "vuex";
    import ScorePredictorService from "../services/scorePredictorService";
    import {ActiveSports} from "@/config/activeSports";

    export default {
        name: "Sports",
        data() {
            return {
                activeClass: 'active-sports-icon-box',
                inActiveClass: 'inactive-sports-icon-box',
                activeSports: ActiveSports,
                orderedActiveSports: [],
            }
        },
        computed: mapState(['sportsWithActiveRounds', 'userData']),

        methods: {
            ...mapMutations([
                'setSelectedSport',
                'setSportsWithActiveRounds',
                'setLeaguesWithActiveRounds',
                'clearSportsWithActiveRounds',
                'clearLeaguesWithActiveRounds',
                'clearRoundPredictions',
                'setLeaderBoardSportSelected',
                'setLeaderboardSelectedUser'
            ]),
            getComingSoonBanner() {
                return require(`../assets/coming_soon_banner.png`);
            },
            getImage(imagePath) {
                return require(`../assets/${this.$environmentConfig.brand}/${imagePath}`);
            },
            onSportClicked(sport) {
                if (this.sportsWithActiveRounds.has(sport)) {
                    this.setSelectedSport(sport);
                    this.$router.push('leagues');
                }
            },
            sportHasActiveRounds(sport) {
                return this.sportsWithActiveRounds.has(sport);
            },
            setOrederedActiveSports() {
                this.activeSports.forEach((sport) => {
                    if (this.sportHasActiveRounds(sport.name)) this.orderedActiveSports.push(sport)
                });
                this.activeSports.forEach((sport) => {
                    if (!this.sportHasActiveRounds(sport.name)) this.orderedActiveSports.push(sport)
                })
            },
            clearState() {
                this.setLeaderBoardSportSelected(undefined);
                this.setLeaderboardSelectedUser(undefined);
                this.clearRoundPredictions();
                this.clearSportsWithActiveRounds();
                this.setSelectedSport(undefined);
            },
        },
        async created() {
            this.clearState();
            const activeRounds = await ScorePredictorService.getLandingPageData(this.userData.msisdn, this.userData.username);
            if (activeRounds.data && activeRounds.data.length > 0) {
                const sportsWithActiveLeagues = new Map();

                activeRounds.data.forEach((activeRound) => {
                    console.log(`Active round: ${activeRound}`);
                    if (sportsWithActiveLeagues.has(activeRound.SportName)) {
                        const leaguesWithActiveRounds = sportsWithActiveLeagues.get(activeRound.SportName);
                        if (leaguesWithActiveRounds.has(activeRound.LeagueName)) {
                            const activeRoundsWithinLeague = leaguesWithActiveRounds.get(activeRound.LeagueName);
                            activeRoundsWithinLeague.push(activeRound);
                        } else leaguesWithActiveRounds.set(activeRound.LeagueName, [activeRound]);
                    } else {
                        const leagueWithActiveRound = new Map();
                        leagueWithActiveRound.set(activeRound.LeagueName, [activeRound]);
                        sportsWithActiveLeagues.set(activeRound.SportName, leagueWithActiveRound);
                    }
                });
                this.setSportsWithActiveRounds(sportsWithActiveLeagues);
                this.setOrederedActiveSports();
            }
        },
    }
</script>

<style scoped lang="scss">
    .coming-soon-banner {
        position: absolute;
        top: -8px;
        left: -8px;
    }

    .sports-container {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        flex-wrap: wrap;
        padding-bottom: 2rem;
    }

    .sports-icon-box {
        width: 40vw;
        height: 40vw;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 2vh;
        padding: 5vw;
        background-color: $icon-container-background-color;
        border-radius: 5px;
        box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, .7),
        0 -0.25rem 1.5rem $icon-container-background-color inset,
        0 0.75rem 0.5rem rgba(238, 238, 238, 0.4) inset,
        0 0.25rem 0.5rem 0 #eceaea inset;
    }

    .active-sports-icon-box {
        opacity: 0.9;
    }

    .active-sports-icon-box:hover {
        cursor: pointer;
        opacity: 1;
    }

    .inactive-sports-icon-box {
        position: relative;
        opacity: 0.4;
    }

    .sports-icon {
        width: 80%;
    }

    @media screen and (min-width: 900px) {
        .sports-icon {
            width: 70%;
        }

        .sports-icon-box {
            width: 25vw;
            height: 25vw;
        }
    }

    .icon-text {
        font-size: 0.8rem;
        margin: 0.5rem 0 0 0;
    }

    .edit-text {
        padding: 0;
        margin: 0;
        font-size: 2vh;
    }

    .line-break {
        color: $line-break-color;
    }
</style>
